import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";

const truncateLabel = (label) => {
  if (label && label.length > 50) {
    return label.slice(0, 47) + "...";
  }
  return label;
};

const MySelect = (props) => {
  const modifiedOptions = props.options.map((option) => ({
    ...option,
    label: truncateLabel(option.label),
  }));

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
      // textOverflow: "ellipsis",
      maxWidth: "100%",
      display: "block",
      paddingRight: "10px",
      // Adjust the number of characters you want to display before ellipsis
    }),
  };

  const handleChange = (selected) => {
    if (
      selected !== null &&
      selected.length > 0 &&
      selected[selected.length - 1].value === props.allOption.value
    ) {
      props.onChange(props.options);
    } else {
      const selectedValues = selected.map((option) => option.value);
      const fullOptions = props.options.filter((option) =>
        selectedValues.includes(option.value)
      );
      props.onChange(fullOptions);
    }
  };

  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...modifiedOptions]}
        onChange={handleChange}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: "white",
          },
        })}
        styles={customStyles} // Apply custom styles
      />
    );
  }

  return <ReactSelect {...props} />;
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

MySelect.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*",
  },
};

export default MySelect;
